import {defineMessage} from 'react-intl';
import * as React from 'react';
import {setup, run} from '../../snippets/go';
import comment from '../../snippets/comment';
import {CreateShellCommand} from '../../../components/left-col';

export const steps = {
  setup,
  create: {},
  customer: {},
  'pass-customer': {},
  imports: {
    body: {
      message: defineMessage({
        id: 'docsApp.ib.aap.server.go.imports.body',
        defaultMessage:
          'Import the Stripe customer and paymentmethod models. Use these models to store information about your customer.',
      }),
    },
  },
  charge: {},
  'run-server': {
    body: {
      message: defineMessage({
        id: 'docsApp.ib.aap.server.go.run-server.body',
        defaultMessage:
          'Run your Go server and go to <a>localhost:4242/checkout.html</a>.',
      }),
      values: {
        a: (str) => (
          <a href="http://localhost:4242/checkout.html" target="_blank">
            {str}
          </a>
        ),
      },
    },
    Component: CreateShellCommand(run),
  },
};

export default ({keys, merchant}) => `package main

import (
  "bytes"
  "encoding/json"
  "io"
  "log"
  "net/http"

  "github.com/stripe/stripe-go"
  "github.com/stripe/stripe-go/paymentintent"
  {?save-card imports}
  "github.com/stripe/stripe-go/customer"
  "github.com/stripe/stripe-go/paymentmethod"
  {/imports}
)

func main() {
  {+setup}
  ${comment && comment(merchant)}
  stripe.Key = "${keys.secret}"
  {/setup}

  fs := http.FileServer(http.Dir("public"))
  http.Handle("/", fs)
  http.HandleFunc("/create-payment-intent", handleCreatePaymentIntent)

  addr := "localhost:4242"
  log.Printf("Listening on %s ...", addr)
  log.Fatal(http.ListenAndServe(addr, nil))
}

type item struct {
  id string
}

func calculateOrderAmount(items []item) int64 {
  // Replace this constant with a calculation of the order's amount
  // Calculate the order total on the server to prevent
  // users from directly manipulating the amount on the client
  return 1099
}

{?save-card charge}
func chargeCustomer(CustomerID string) {
  params := &stripe.PaymentMethodListParams{
    Customer: stripe.String(CustomerID),
    Type:     stripe.String(string(stripe.PaymentMethodTypeCard)),
  }
  i := paymentmethod.List(params)

  for i.Next() {
    pm := i.PaymentMethod()
    piparams := &stripe.PaymentIntentParams{
      Amount:        stripe.Int64(1099),
      Currency:      stripe.String(string(stripe.CurrencyUSD)),
      Customer:      stripe.String(CustomerID),
      PaymentMethod: stripe.String(pm.ID),
      Confirm:       stripe.Bool(true),
      OffSession:    stripe.Bool(true),
    }

		pi, _ := paymentintent.New(piparams)
		log.Printf("pi.Status: %v", pi.Status)
	}
}

{/charge}
func handleCreatePaymentIntent(w http.ResponseWriter, r *http.Request) {
  if r.Method != "POST" {
    http.Error(w, http.StatusText(http.StatusMethodNotAllowed), http.StatusMethodNotAllowed)
    return
  }

  var req struct {
    Items []item \`json:"items"\`
  }

  if err := json.NewDecoder(r.Body).Decode(&req); err != nil {
    http.Error(w, err.Error(), http.StatusInternalServerError)
    log.Printf("json.NewDecoder.Decode: %v", err)
    return
  }
  {?save-card customer}
  // Alternatively, set up a webhook to listen for the payment_intent.succeeded event
  // and attach the PaymentMethod to a new Customer
  cparams := &stripe.CustomerParams{}

  c, _ := customer.New(cparams)
  {/customer}

  {+create}
  params := &stripe.PaymentIntentParams{
    Amount:   stripe.Int64(calculateOrderAmount(req.Items)),
    Currency: stripe.String(string(stripe.CurrencyUSD)),
    {?save-card pass-customer}
    Customer: stripe.String(c.ID),
    SetupFutureUsage: stripe.String("off_session"),
    {/pass-customer}
  }

  {span response create}pi{/span}, err := paymentintent.New(params)
  log.Printf("pi.New: %v", pi.ClientSecret)

  if err != nil {
    http.Error(w, err.Error(), http.StatusInternalServerError)
    log.Printf("pi.New: %v", err)
    return
  }

  writeJSON(w, struct {
    ClientSecret string \`json:"clientSecret"\`
  }{
    ClientSecret: pi.ClientSecret,
  })
  {/create}
}

func writeJSON(w http.ResponseWriter, v interface{}) {
  var buf bytes.Buffer
  if err := json.NewEncoder(&buf).Encode(v); err != nil {
    http.Error(w, err.Error(), http.StatusInternalServerError)
    log.Printf("json.NewEncoder.Encode: %v", err)
    return
  }
  w.Header().Set("Content-Type", "application/json")
  if _, err := io.Copy(w, &buf); err != nil {
    log.Printf("io.Copy: %v", err)
    return
  }
}
`;
